/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_No_OrdersInputs */

const vi_driver_no_orders = /** @type {(inputs: Driver_No_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn hàng nào đang chờ.`)
};

/**

* @param {Driver_No_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_no_orders = /** @type {((inputs?: Driver_No_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_No_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_no_orders(inputs)
});